import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_INVOICE_CLIENT_LOADING = 'POST_INVOICE_CLIENT_LOADING';
export const POST_INVOICE_CLIENT_SUCCESS = 'POST_INVOICE_CLIENT_SUCCESS';
export const POST_INVOICE_CLIENT_REJECT  = 'POST_INVOICE_CLIENT_REJECT';
export const POST_INVOICE_CLIENT_RESET   = 'POST_INVOICE_CLIENT_RESET';

//* ACTIONS ------------------------------------------------
export const postInvoiceClientLoading = () => ({ type: POST_INVOICE_CLIENT_LOADING });
export const postInvoiceClientSuccess = (payload) => ({ type: POST_INVOICE_CLIENT_SUCCESS, payload });
export const postInvoiceClientReject  = (payload) => ({ type: POST_INVOICE_CLIENT_REJECT,  payload });
export const postInvoiceClientReset   = () => ({ type: POST_INVOICE_CLIENT_RESET });

//* REQUEST SERVICE ----------------------------------------
export const postInvoiceClientRequest = async (body = {}, getState) => {
    const options = await withToken({
        method: Methods.POST,
        data: body,
    }, getState);
    return request(`/Invoices/web/AddInvoices`, options);
};
